import React from 'react';
import clsx from 'clsx';
import { CancelButton, ConfirmButton } from '../../../../../../styling/Styles';

const EditFormFunctionsRow = (props) => {
  const {
    setOpenAlert,
    setClickedEdit,
    editor,
    componentsInfo,
    rowsComponentsIds,
    deleteComps,
    savedPageClicked,
    setClickedButtonGenerate,
    selectedProject
  } = props;

  // This function closes the edit form pop up window
  const handleCancel = () => {
    setOpenAlert(false);
    setClickedEdit(false);
  };

  const findId = (pageName) => {
    let id = -1;

    const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;

    tempData.forEach((page) => {
      if (page.name === pageName) {
        id = page.pageId;
      }
    });

    return id;
  };

  // This function updates all the changes in the edit form pop up and then closes the pop up
  const updateAttributes = () => {
    const selectedComponent = editor.getSelected();

    deleteComps.forEach((deleteCompId) => {
      const deleteComp = editor.DomComponents.componentsById[deleteCompId];
      if (deleteComp !== undefined) {
        deleteComp.remove();
      }
    });

    componentsInfo.forEach((insideDiv, index) => {
      if (rowsComponentsIds[index].id === -1) {
        selectedComponent.append({
          tagName: 'div',
          classes: ['flex']
        });
      }

      insideDiv.div.forEach((insideComp, index2) => {
        const insideCompId = rowsComponentsIds[index].insideIds[index2];
        const lengthModels = selectedComponent.attributes.components.models.length;

        if (insideComp === 'label') {
          if (insideCompId !== -1) {
            const componentId = rowsComponentsIds[index].insideIds[index2];
            const componentLabel = editor.DomComponents.componentsById[componentId];
            const {label} = componentsInfo[index].info[index2];

            componentLabel.components(label);
          } else {
            const {label} = componentsInfo[index].info[index2];
            let rowComp = '';
            if (rowsComponentsIds[index].id === -1) {
              rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
            } else {
              rowComp = selectedComponent.attributes.components.models[index];
            }
            const tempComponents = { type: 'label', components: label , classes: ['col-form-label']};

            rowComp.append(tempComponents);
          }
        } else if (insideComp === 'button') {
          if (insideCompId !== -1) {
            const componentId = rowsComponentsIds[index].insideIds[index2];
            const componentButton = editor.DomComponents.componentsById[componentId];
            const methodOption = componentsInfo[index].info[index2].method;
            const {label} = componentsInfo[index].info[index2];
            const {href} = componentsInfo[index].info[index2];
            const targetPageName = componentsInfo[index].info[index2].target_page;

            const target_page = findId(targetPageName);

            if (componentButton !== undefined) {
              componentButton.components(label);

              componentButton.addAttributes({ method: methodOption });

              if (href !== '') {
                componentButton.addAttributes({ href });
                const attr = componentButton.getAttributes();
                delete attr.target_page;
                componentButton.setAttributes(attr);
              } else if (target_page !== 'undefined' || target_page !== '') {
                componentButton.addAttributes({ target_page });
                const attr = componentButton.getAttributes();
                delete attr.href;
                componentButton.setAttributes(attr);
              }
            }
          } else {
            const {label} = componentsInfo[index].info[index2];
            const {method} = componentsInfo[index].info[index2];

            const {href} = componentsInfo[index].info[index2];
            const targetPageName = componentsInfo[index].info[index2].target_page;
            const target_page = findId(targetPageName);

            let rowComp = '';
            if (rowsComponentsIds[index].id === -1) {
              rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
            } else {
              rowComp = selectedComponent.attributes.components.models[index];
            }

            const tempAttributes = {};
            if (target_page !== undefined && target_page !== '' && target_page !== 'undefined') {
              tempAttributes.target_page = target_page;
            }
            if (method !== undefined && method !== '') {
              tempAttributes.method = method;
            }
            if (href !== undefined && href !== -1 && href !== '') {
              tempAttributes.href = href;
            }

            const tempComponents = {
              type: 'button',
              components: label,
              attributes: tempAttributes,
              classes: ['btn', 'btn-primary', 'pointer']
            };
            rowComp.append(tempComponents);
          }
        } else if (insideComp === 'textarea') {
          if (insideCompId !== -1) {
            const componentId = rowsComponentsIds[index].insideIds[index2];
            const componentTextArea = editor.DomComponents.componentsById[componentId];
            const {placeholder} = componentsInfo[index].info[index2];
            const {required} = componentsInfo[index].info[index2];

            if (componentTextArea !== undefined) {
              if (placeholder !== '' && placeholder !== undefined) {
                componentTextArea.addAttributes({ placeholder });
              }
              componentTextArea.addAttributes({ required });
            }
          } else {
            const {placeholder} = componentsInfo[index].info[index2];
            const {required} = componentsInfo[index].info[index2];
            let rowComp = '';

            if (rowsComponentsIds[index].id === -1) {
              rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
            } else {
              rowComp = selectedComponent.attributes.components.models[index];
            }
            const tempComponents = {
              type: 'textarea',
              attributes: {
                placeholder,
                required
              },
              classes: ['form-control']
            };
            rowComp.append(tempComponents);
          }
        } else if (insideComp === 'input') {
          if (insideCompId !== -1) {
            const componentId = rowsComponentsIds[index].insideIds[index2];
            const componentInput = editor.DomComponents.componentsById[componentId];
            const {placeholder} = componentsInfo[index].info[index2];
            const {required} = componentsInfo[index].info[index2];
            const {type} = componentsInfo[index].info[index2];

            if (componentInput !== undefined) {
              if (placeholder !== '' && placeholder !== undefined) {
                componentInput.addAttributes({ placeholder });
              }
              componentInput.addAttributes({ required });
              componentInput.addAttributes({ type });
            }
          } else {
            const {type} = componentsInfo[index].info[index2];
            const {placeholder} = componentsInfo[index].info[index2];

            let rowComp = '';
            if (rowsComponentsIds[index].id === -1) {
              rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
            } else {
              rowComp = selectedComponent.attributes.components.models[index];
            }
            const tempComponents = {
              type: 'input',
              attributes: { placeholder, type },
              classes: ['form-control']
            };
            rowComp.append(tempComponents);
          }
        } else if (insideComp === 'dropdown') {
          if (insideCompId !== -1) {
            const componentId = rowsComponentsIds[index].insideIds[index2];
            const {label} = componentsInfo[index].info[index2];
            const {options} = componentsInfo[index].info[index2];

            const domComponents = editor.DomComponents;
            const dropdownComponent = domComponents.componentsById[componentId];
            const dropdownModels = dropdownComponent.attributes.components.models;

            if (dropdownModels.length > 0 && dropdownModels[0].attributes.tagName === 'button') {
              const dropdownButton = dropdownModels[0];

              dropdownButton.components(label);
            }

            const existedOptionsLength = dropdownModels[1].attributes.components.models.length;

            if (dropdownModels.length > 1 && dropdownModels[1].attributes.tagName === 'ul') {
              const dropdownUl = dropdownModels[1];

              const dropdownOptions = dropdownUl.attributes.components.models;

              options.forEach((option, index3) => {
                if (index3 + 1 <= existedOptionsLength) {
                  const componentOption = dropdownOptions[index3].attributes.components.models[0];
                  componentOption.components(option);
                } else {
                  dropdownUl.append({
                    tagName: 'li',
                    components: [
                      {
                        tagName: 'a',
                        type: 'link',
                        components: option,
                        classes: ['dropdown-item']
                      }
                    ]
                  });
                }
              });

              dropdownOptions.forEach((dropdownOption, index4) => {
                if (index4 + 1 > options.length) {
                  dropdownOption.remove();
                }
              });
            }
          } else {
            const tempComponentsOptions = [];

            const {options} = componentsInfo[index].info[index2];
            options.forEach((option) => {
              tempComponentsOptions.push({
                tagName: 'li',
                components: [
                  {
                    tagName: 'a',
                    type: 'link',
                    components: option,
                    classes: ['dropdown-item']
                  }
                ]
              });
            });

            const {label} = componentsInfo[index].info[index2];
            const DropdownComponent = {
              tagName: 'span',
              attributes: { wablitype: 'dropdown' },
              classes: ['dropdown','dropdown-container'],
              components: [
                {
                  type: 'button',
                  attributes: {
                    'aria-expanded': false,
                    'data-bs-toggle': 'dropdown',
                    id: 'dropdownMenuButton1-2',
                    wablitype: 'button',
                    wabliname: 'button'
                  },
                  classes: ['btn', 'btn-secondary', 'dropdown-toggle'],
                  components: label
                },
                {
                  tagName: 'ul',
                  attributes: {
                    'aria-labelledby': 'dropdownMenuButton1'
                  },
                  classes: ['dropdown-menu'],
                  components: tempComponentsOptions
                }
              ]
            };

            let rowComp = '';
            if (rowsComponentsIds[index].id === -1) {
              rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
            } else {
              rowComp = selectedComponent.attributes.components.models[index];
            }

            rowComp.append(DropdownComponent);
          }
        } else if (insideComp === 'radio') {
          componentsInfo[index].info[index2].ids.forEach((id, index3) => {
            if (id !== -1) {
              const radioComponent = editor.DomComponents.componentsById[id];
              const label = componentsInfo[index].info[index2].labels[index3];

              radioComponent.attributes.components.models.forEach((insideRadioComp) => {
                if (insideRadioComp.attributes.tagName === 'label') {
                  insideRadioComp.components(label);
                }
                else if(insideRadioComp.attributes.tagName === 'input'){
                  insideRadioComp.addAttributes({ value: label });
                }
              });
            } else {
              let rowComp = '';
              if (rowsComponentsIds[index].id === -1) {
                rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
              } else {
                rowComp = selectedComponent.attributes.components.models[index];
              }

              const label = componentsInfo[index].info[index2].labels[index3];
              const appendContent = (
                <div wablitype="radios" className={clsx('form-check', 'form-check-inline', 'flex')}>
                  <input value={label} type="radio" id='radioInput' checked className="form-check-input" />
                  <label htmlFor='radioInput' className="form-check-label">{label}</label>
                </div>
              );
              rowComp.append(appendContent, { at: index2 + index3 });
            }
          });
        } else if (insideComp === 'checkbox') {
          if (insideCompId === -1) {
            const {checked} = componentsInfo[index].info[index2];
            let rowComp = '';
            if (rowsComponentsIds[index].id === -1) {
              rowComp = selectedComponent.attributes.components.models[lengthModels - 1];
            } else {
              rowComp = selectedComponent.attributes.components.models[index];
            }
            const tempComponents = { type: 'checkbox', attributes: { checked } , classes: ['margin-left']};

            rowComp.append(tempComponents);
          }
        }
      });
    });

    savedPageClicked();
    setOpenAlert(false);
    setClickedEdit(false);
  };

  /*
    This function is connected with 'Generate block' button and when is clicked the edit options are replaced with a different pop up
    window to give a name for the new block
    */
  const activateGenerateButton = () => {
    setClickedButtonGenerate(true);
  };

  return (
    <div
      className={clsx('flex-container', 'spacingDownDiv')}
      style={{
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        marginTop: '1vw',
        minWidth: '30vw'
      }}
    >
      <div>
        <CancelButton onClick={handleCancel}>Cancel</CancelButton>
      </div>
      <div className={clsx('flexRowDirection')}>
        <ConfirmButton onClick={updateAttributes}>Save</ConfirmButton>
        <div> &nbsp;</div>
        <ConfirmButton onClick={activateGenerateButton}>Generate block</ConfirmButton>
      </div>
    </div>
  );
};

export default EditFormFunctionsRow;
